import * as types from './types'
import globals from '@/plugins/globals.js'
import store from '@/store'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.REQUEST_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.REQUEST_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.REQUEST_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.REQUEST_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.REQUEST_FILTER_BY, filterBy)
  },
  [types.SET_RETRO_DAY](state, day) {
    state.retrospectiveDay = day
    storage.session.setItem(types.REQUEST_RETRO_DAY, day)
  },
  [types.SET_STATUS](state, status) {
    state.status = status
    storage.local.setItem(types.REQUEST_STATUS, status)
  },
  [types.SET_SYNC_COLUMNS](state, value) {
    state.syncColumns = value
    storage.local.setItem(types.SYNC_COLUMNS, JSON.stringify(value))
  },
  [types.UPDATE_DEVICE](state, device) {
    // update the Device
    if (state.request !== undefined && state.request !== null) {
      if (state.request.Vehicle.VIN === device.vin) {
        state.request.Device = {
          FriendlyName: device.name,
          Id: device.id,
          SerialNumber: device.sn
        }
      }
    }
  },
  [types.SET_NEW_REQUEST](state) {
    // set up a new Service Request
    let language = store.getters['auth/language']
    state.request = JSON.parse(JSON.stringify(state.cleanRequest))
    let location = {
      CultureCode: language + '-' + language.toUpperCase()
    }
    state.request.Contact.Location = location
  },
  [types.RESET_REQUESTS](state) {
    // reset the Service Request list
    state.requests = []
  },
  [types.SET_REQUESTS](state, requests) {
    // set the list of Service Requests
    requests.forEach(function (element) {
      element.chatUnread = 0
      if (element.StatusName === 'Scheduled') {
        if (element.ScheduleDates !== '') {
          var dates = JSON.parse(element.ScheduleDates)
          if (dates !== undefined && dates !== null) {
            var date = new Date(dates[0].Date)
            element.Scheduled = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
          }
        }
      }
    }, this)
    state.requests = requests
  },
  [types.SET_REQUEST](state, request) {
    // set the Service Request (pulled down from API Services)
    let language = store.getters['auth/language']
    state.request = undefined
    state.noRequest = false
    if (request !== undefined && request !== null) {
      state.request = request[0]
      if (state.request !== undefined && state.request !== null) {
        if (state.request.IsSRS !== null) {
          state.request.IsSRS = state.request.IsSRS.toString()
        }
        if (state.request.IsDrivable !== null) {
          state.request.IsDrivable = state.request.IsDrivable.toString()
        }
        if (state.request.IsMil !== null) {
          state.request.IsMil = state.request.IsMil.toString()
        }
        if (globals.currentPage === 'Pending') {
          state.request.IsSRS = null
          state.request.IsDrivable = null
          state.request.IsMil = null
        }
        let location = {
          CultureCode: language + '-' + language.toUpperCase()
        }
        if (state.request.Contact !== null) {
          state.request.Contact.Location = location
        }
        if (state.request.Id !== null) {
          for (let request of state.requests) {
            if (request.Id === state.request.Id) {
              state.request.chatUnread = request.chatUnread
              break
            }
          }
        }
      } else {
        state.request = undefined
        state.noRequest = true
      }
    }
  },
  [types.SET_VEHICLEINFO](state) {
    // reset the Vehicle drop-downs (and vehicle info)
    state.newVehicle = JSON.parse(JSON.stringify(state.cleanVehicle))
    state.makes = []
    state.models = []
    state.submodels = []
    state.engines = []
    state.transmissions = []
    state.drivetypes = []
    state.request.Vehicle = JSON.parse(JSON.stringify(state.cleanVehicle))
  },
  [types.SET_VEHICLE](state, data) {
    // set the Vehicle info
    state.request.Vehicle.VIN = data.VIN
    state.request.Vehicle.Year = data.Year
    state.request.Vehicle.DriveType.Id = data.DriveType.Id
    state.request.Vehicle.Engine.Id = data.Engine.Id
    state.request.Vehicle.Make.Id = data.Make.Id
    state.request.Vehicle.Model.Id = data.Model.Id
    state.request.Vehicle.Odometer = data.Odometer
    state.request.Vehicle.OdometerUnits.Id = data.OdometerUnits.Id
    state.request.Vehicle.Submodel.Id = data.Submodel.Id
    state.request.Vehicle.Transmission.Id = data.Transmission.Id
  },
  [types.SET_REQUESTCOUNTS](state, counts) {
    // set the Service Request Counts (on the main page)
    if (counts !== undefined && counts !== null) {
      if (counts.listWorkOrders !== undefined && counts.listWorkOrders !== null) {
        counts.listWorkOrders = JSON.parse(counts.listWorkOrders)
      }
      state.requestCount = counts
    }
  },
  [types.UPDATE_TOTAL_UNREAD](state, unread) {
    // set total unread chats
    state.totalUnreadChats = unread
  },
  [types.UPDATE_UNREAD](state, channels) {
    // update the Unread count
    for (let channel of channels) {
      for (let request of state.requests) {
        if (channel.name === request.Id.toString()) {
          request.chatUnread = parseInt(channel.unreadMessageCount)
          break
        }
      }
    }
  },
  [types.UPDATE_REQUEST_UNREAD](state, unread) {
    // set the Unread count
    state.requestUnreadCount = unread
  },
  [types.RESET_REQUEST_UNREAD](state, id) {
    // set Unread flag
    state.requestUnreadReset = id
  },
  [types.SET_VIN_SUMMARY](state, vinSummary) {
    // set the VIN summary
    state.vinSummary = null
    if (vinSummary !== undefined && vinSummary !== null) {
      state.vinSummary = vinSummary
    }
  },
  [types.SET_VIN_SUMMARY_UK](state, vinSummary) {
    // process the decoded VIN information (from UK)
    state.vinSummary = null
    if (vinSummary !== undefined && vinSummary !== null) {
      if (vinSummary.yearId !== null) {
        state.request.Vehicle.Year = parseInt(vinSummary.yearId)
        if (vinSummary.make !== null) {
          state.request.Vehicle.Make.Text = vinSummary.make.name
        }
        if (vinSummary.model !== null) {
          state.request.Vehicle.Model.Text = vinSummary.model.name
        }
        if (vinSummary.submodel !== null) {
          state.request.Vehicle.Submodel.Text = vinSummary.submodel.name
        }
        if (vinSummary.transmission !== null) {
          state.request.Vehicle.Transmission.Text = vinSummary.transmission.name
        }
        if (vinSummary.engine !== null) {
          state.request.Vehicle.Engine.BlockType = vinSummary.engine.name
        }
      }
    }
  },
  [types.SET_YEARS](state, years) {
    // load up the Years
    state.years = []
    if (years !== undefined && years !== null) {
      years.forEach(element => {
        state.years.push({
          value: element,
          name: element
        })
      })
    }
  },
  [types.SET_MAKES](state, makes) {
    // load up the Makes
    if (makes !== undefined && makes !== null) {
      state.makes = []
      makes.forEach(element => {
        state.makes.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_MODELS](state, models) {
    // load up the Models
    if (models !== undefined && models !== null) {
      state.models = []
      models.forEach(element => {
        state.models.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_SUBMODELS](state, submodels) {
    // load up the Submodels
    if (submodels !== undefined && submodels !== null) {
      state.submodels = []
      submodels.forEach(element => {
        state.submodels.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_ENGINES](state, engines) {
    // load up the Engines
    if (engines !== undefined && engines !== null) {
      state.engines = []
      engines.forEach(element => {
        state.engines.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_TRANSMISSIONS](state, transmissions) {
    // load up the Transmissions
    if (transmissions !== undefined && transmissions !== null) {
      state.transmissions = []
      transmissions.forEach(element => {
        state.transmissions.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_DRIVETYPES](state, drivetypes) {
    // load up the Drive Types
    if (drivetypes !== undefined && drivetypes !== null) {
      state.drivetypes = []
      drivetypes.forEach(element => {
        state.drivetypes.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_SCANTYPES](state, scantypes) {
    // load up the Scan Types
    let _scanTypes = []
    if (scantypes !== undefined && scantypes !== null) {
      for (let type of scantypes) {
        _scanTypes.push({
          value: type.id,
          name: type.text
        })
      }
    }
    state.scantypes = _scanTypes
    storage.local.setItem(types.SESSION_SCANTYPES, JSON.stringify(state.scantypes))
  },
  [types.SET_REQUESTID](state, data) {
    // set the Service Request ID (from a Create)
    if (data !== undefined && data !== null) {
      state.id = data.id
      state.request.Id = data.id
    }
  },
  [types.SET_REQUESTSTATUS](state, data) {
    // set the Service Request Status after an update
    if (data !== undefined && data !== null) {
      state.request.Status.Id = data.Status.Id
      state.request.Status.Name = data.Status.Name
    }
  },
  [types.SET_REQUEST_SCAN_TYPE](state, data) {
    // set the Service Request Scan Type after an update
    if (data !== undefined && data !== null) {
      state.request.ScanType.Id = data.value
      state.request.ScanType.Name = data.text
    }
    let status = {
      id: data.id,
      scanTypeId: data.value,
      scanTypeName: data.text
    }
    store.dispatch('astechhub/setScanType', status)
  },
  [types.REFRESH_REQUEST](state, data) {
    // freshen the Service Request with info
    state.request.ScanReport.Id = data.ScanReportId
    state.request.ScanReport.Status.Text = data.ScanReportStatus
    state.request.Status.Text = data.WorkOrderStatus
    state.request.ScanReport.InvoiceNumber = data.InvoiceNumber
  },
  [types.SET_STATUSLIST](state, statuslist) {
    // set the Status list
    if (statuslist !== undefined && statuslist !== null) {
      state.statuslist = statuslist
    }
  },
  [types.SET_REQUEST_HISTORY](state, data) {
    // set the Service Request History
    state.requestHistory = null
    if (data !== '') {
      state.requestHistory = data
    }
  },
  [types.UPDATE_REQUEST_RECORD](state, data) {
    // update the Service Request record as data changes
    let appId = globals.getApp()
    let isUK = false
    if (parseInt(appId) === 1) {
      isUK = true
    }
    if (state.request !== undefined && state.request !== null && data !== null) {
      switch (data.item) {
        case 'AppId':
          state.request.AppId = data.value
          break
        case 'RONumber':
          state.request.RONumber = data.value
          break
        case 'Insurance':
          state.request.Vehicle.Insurance.Id = data.value
          break
        case 'ScanType':
          state.request.ScanType.Id = data.value
          break
        case 'Device':
          state.request.Device.Id = data.value
          break
        case 'DeviceName':
          state.request.Device.FriendlyName = data.value
          break
        case 'VIN':
          state.request.Vehicle.VIN = data.value
          break
        case 'Year':
          state.request.Vehicle.Year = data.value
          break
        case 'Make':
          if (!isUK) {
            state.request.Vehicle.Make.Id = data.value
          } else {
            state.request.Vehicle.Make.Text = data.value
          }
          break
        case 'Model':
          if (!isUK) {
            state.request.Vehicle.Model.Id = data.value
          } else {
            state.request.Vehicle.Model.Text = data.value
          }
          break
        case 'Model2':
          if (!isUK) {
            state.request.Vehicle.Model.Id = parseInt(data.value)
            for (let model of state.models) {
              if (model.Id === parseInt(data.value)) {
                state.request.Vehicle.Model.Text = model.Text
              }
            }
          }
          break
        case 'Submodel':
          if (!isUK) {
            state.request.Vehicle.Submodel.Id = data.value
          } else {
            state.request.Vehicle.Submodel.Text = data.value
          }
          break
        case 'Engine':
          if (!isUK) {
            state.request.Vehicle.Engine.Id = data.value
          } else {
            state.request.Vehicle.Engine.BlockType = data.value
          }
          break
        case 'Transmission':
          if (!isUK) {
            state.request.Vehicle.Transmission.Id = data.value
          } else {
            state.request.Vehicle.Transmission.Text = data.value
          }
          break
        case 'DriveType':
          if (!isUK) {
            state.request.Vehicle.DriveType.Id = data.value
          } else {
            state.request.Vehicle.DriveType.Text = data.value
          }
          break
        case 'Odometer':
          state.request.Vehicle.Odometer = data.value
          break
        case 'OdometerUnits':
          state.request.Vehicle.OdometerUnits.Id = data.value
          break
        case 'IsSRS':
          state.request.IsSRS = data.value
          break
        case 'IsMIL':
          state.request.IsMil = data.value
          break
        case 'IsDrivable':
          state.request.IsDrivable = data.value
          break
        case 'ShopComments':
          state.request.ShopComments = data.value
          break
        case 'ScheduleDate':
          state.request.ScheduleDates = []
          if (data.value !== undefined && data.value !== null) {
            data.value = new Date(data.value).toISOString()
            state.request.ScheduleDates.push({
              Date: data.value,
              UserTimeZone: ''
            })
          }
          break
        case 'UserInfo':
          state.request.Location.Id = data.value.location.Id
          state.request.Contact.Id = data.value.id
          state.request.Contact.GivenName = data.value.firstName
          state.request.Contact.FamilyName = data.value.lastName
          state.request.Contact.PhoneNumber = data.value.phone
          state.request.Contact.Email = data.value.email
          if (state.request.Id === 0) {
            state.request.CreatedBy = data.value.id
            state.request.CreatedDate = new Date().toISOString()
          }
          state.request.UpdatedBy = data.value.id
          state.request.UpdatedDate = new Date().toISOString()
          if (state.request.ScheduleDates !== undefined && state.request.ScheduleDates !== null) {
            if (state.request.ScheduleDates.length > 0) {
              state.request.ScheduleDates[0].UserTimeZone = data.value.timeZone
            }
          }
          delete state.request.Device.FriendlyName
          delete state.request.Device.SerialNumber
          break
      }
    }
  },
  [types.SET_REQUEST_NOTES](state, data) {
    // set the Service Request notes
    state.request.Notes.Notes = data.Notes
  },
  [types.SET_STATE_DEFAULT](state, type) {
    // set the Notes defaults
    state.stateDefaults = {
      notesAssembled: 'Vehicle is fully assembled. ',
      notesDisassembled: 'Vehicle is disassembled. ',
      notesStateSRS: 'Vehicle has SRS deployment(s): ',
      notesStateSRSon: 'Vehicle has SRS deployment(s) [XX]. ',
      notesStateSRSoff: 'SRS not deployed. ',
      notesWarningLights: 'Warning lights illuminated: ',
      notesWarningLightsOn: 'Warning lights illuminated [XX]. ',
      notesWarningLightsOff: 'No warning lights illuminated. ',
      notesBatterySupported: 'Battery supported. ',
      notesBatteryNotSupported: 'Battery not supported. ',
      notesKeyEngineStateKOEO: 'Key on, engine off. ',
      notesKeyEngineStateKOER: 'Key on, engine running. '
    }
  },
  [types.SET_STATE_ASSEMBLY](state, type) {
    // Notes: set state of assembly
    state.stateAssemblyOptions = [{
      name: 'select option',
      value: ''
    },
    {
      name: 'Disassembled',
      value: 'Disassembled'
    },
    {
      name: 'Assembled',
      value: 'Assembled'
    }
    ]
  },
  [types.SET_STATE_SRS](state, type) {
    // Notes: set state of SRS
    state.stateSrsOptions = [{
      name: 'None',
      value: 'None'
    },
    {
      name: 'Curtain',
      value: 'Curtain'
    },
    {
      name: 'Dash',
      value: 'Dash'
    },
    {
      name: 'Headrests',
      value: 'Headrests'
    },
    {
      name: 'Seat Belts',
      value: 'Seat Belts'
    },
    {
      name: 'Side Airbags',
      value: 'Side Airbags'
    },
    {
      name: 'Steering Wheel/Column',
      value: 'Steering Wheel/Column'
    },
    {
      name: 'Other [XX]',
      value: 'Other [XX]'
    }
    ]
  },
  [types.SET_STATE_LIGHTS](state, type) {
    // Notes: set state of Lights
    state.stateLightOptions = [{
      name: 'None',
      value: 'None'
    },
    {
      name: 'ABS/Traction',
      value: 'ABS/Traction'
    },
    {
      name: 'Check Engine',
      value: 'Check Engine'
    },
    {
      name: 'Driver Assist',
      value: 'Driver Assist'
    },
    {
      name: 'SRS',
      value: 'SRS'
    },
    {
      name: 'TPMS',
      value: 'TPMS'
    },
    {
      name: 'Other [XX]',
      value: 'Other [XX]'
    }
    ]
  },
  [types.SET_STATE_KEY_ENGINE](state, type) {
    // Notes: set state of Key On/Engine On
    state.stateKeyEngineOptions = [{
      name: 'select option',
      value: ''
    },
    {
      name: 'Key On, Engine Off',
      value: 'KOEO'
    },
    {
      name: 'Key On, Engine Running',
      value: 'KOER'
    }
    ]
  },
  [types.SET_STATE_DAMAGE_LEVEL](state, type) {
    // Notes: set state of Damage Levels
    state.stateDamageLevelOptions = [{
      name: 'select option',
      value: ''
    },
    {
      name: 'Light',
      value: 'Light'
    },
    {
      name: 'Moderate',
      value: 'Moderate'
    },
    {
      name: 'Severe',
      value: 'Severe'
    }
    ]
  },
  [types.SET_STATE_DAMAGE_POSITION](state, type) {
    // Notes: set Damage Position
    state.stateDamagePositionOptions = []
    for (let position of state.damagePositions) {
      state.stateDamagePositionOptions.push({
        name: position.text,
        value: position.text
      })
    }
  },
  [types.UPDATE_SCAN_REPORT_FOLLOW_UP](state, value) {
    // set Scan Report as Follow up (or not)
    if (value) {
      state.request.ScanReport.IsFollowupScan = 1
    } else {
      state.request.ScanReport.IsFollowupScan = 0
    }
  },
  [types.UPDATE_CALIBRATION_COMPLETE](state, value) {
    // set Calibration is Complete flag (mainly used for Hunter, but can be used for others)
    if (value) {
      state.request.ScanReport.IsCalibrationPassed = 1
    } else {
      state.request.ScanReport.IsCalibrationPassed = 0
    }
  },
  [types.UPDATE_SCAN_REPORT](state, details) {
    // update the Scan Report information during data updates
    switch (details.area) {
      case 'ServiceDetails':
        state.request.ScanReport.ServiceDetails = details.data
        break
      case 'Recommendations':
        state.request.ScanReport.Recommendations = details.data
        break
      case 'ScanReadings':
        state.request.ScanReport.ScanReadings = details.data
        break
      case 'SnapShotData':
        state.request.ScanReport.SnapshotData = details.data
        break
    }
  },
  [types.UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING](state, value) {
    // set the Scan Report Performing Programming flag
    if (value) {
      state.request.ScanReport.IsProgrammingPerformed = 1
    } else {
      state.request.ScanReport.IsProgrammingPerformed = 0
    }
  },
  [types.SET_SHOP_DEVICE](state, device) {
    // set the Service Request Device
    state.request.Device = {
      FriendlyName: device.friendlyName,
      Id: device.id,
      SerialNumber: device.serialNumber
    }
    if (state.requests !== undefined && state.requests !== null) {
      if (state.requests.length > 0) {
        for (let request of state.requests.items) {
          if (request.id === state.request.Id) {
            request.deviceId = device.id
            request.deviceFriendlyName = device.friendlyName
            request.deviceSerialNumber = device.value
            break
          }
        }
      }
    }
  },
  [types.SET_CALIBRATE_CONFIG](state, data) {
    // set the Calibration Configuration info
    state.calibrateConfiguration = {
      damages: [],
      reasons: [],
      systems: [],
      fixtures: [],
      images: [],
      notes: [],
      state: '',
      recommendations: '',
      aiming: ''
    }
    if (data !== undefined && data !== null) {
      if (data !== '') {
        data.forEach(element => {
          switch (element.Key) {
            case 'damage':
              state.calibrateConfiguration.damages.push(element.Calibration)
              break
            case 'reason':
              if (element.Additional !== null) {
                state.calibrateConfiguration.reasons.push(`${element.Calibration}: ${element.Additional}`)
              } else {
                state.calibrateConfiguration.reasons.push(element.Calibration)
              }
              break
            case 'system':
              if (element.Additional !== null) {
                state.calibrateConfiguration.systems.push(`${element.Calibration}: ${element.Additional}`)
              } else {
                state.calibrateConfiguration.systems.push(element.Calibration)
              }
              break
            case 'fixture':
              if (element.Additional !== null) {
                state.calibrateConfiguration.fixtures.push(`${element.Calibration}: ${element.Additional}`)
              } else {
                state.calibrateConfiguration.fixtures.push(element.Calibration)
              }
              break
            case 'image':
              state.calibrateConfiguration.images.push(element.Calibration)
              break
            case 'note':
              state.calibrateConfiguration.notes += element.Calibration
              break
            case 'state':
              // console.log('State', JSON.parse(element.Calibration))
              state.calibrateConfiguration.state = element.Calibration !== undefined && element.Calibration !== null ? JSON.parse(element.Calibration) : null
              break
            case 'recommendations':
              state.calibrateConfiguration.recommendations = element.Calibration !== undefined && element.Calibration !== null ? JSON.parse(element.Calibration) : null
              break
            case 'aimingsnap':
              state.calibrateConfiguration.aiming = element.Calibration !== undefined && element.Calibration !== null ? JSON.parse(element.Additional) : null
              break
          }
        })
      }
    }
  },
  [types.UPDATE_CALIBRATE_CONFIG](state, data) {
    // update the Calibration Config info with changes
    if (state.calibrateConfiguration !== undefined && state.calibrateConfiguration !== null && data !== null) {
      switch (data.item) {
        case 'prepNotes':
          state.calibrateConfiguration.state.prepInstructions = data.value
          break
        case 'scanProgress':
          state.calibrateConfiguration.state.scanProgress = data.value
          break
        case 'quickscanResult':
          state.calibrateConfiguration.state.quickscanResult = data.value
          break
        case 'quickscanNotes':
          state.calibrateConfiguration.state.quickscanNotes = data.value
          break
        case 'preppedCalibration':
          state.calibrateConfiguration.state.preppedCalibration = data.value
          break
        case 'scanComplete':
          state.calibrateConfiguration.state.scanComplete = data.value
          break
        case 'reportSent':
          state.calibrateConfiguration.state.reportSent = data.value
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/mutations.js